(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbw-product-downloads"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tbwProductClipPlayback) return;
  window.tbwProductClipPlayback = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const clips = new Map();
  const automatic = () => !motion.matches && !connection?.saveData;
  function pauseClip(video, state) {
    if (!video.paused) {
      state.internalPause = true;
      video.pause();
    }
  }
  function updateClip(video, state) {
    video.dataset.tbwClipPlayback = automatic() ? 'viewport' : 'manual';
    if (document.hidden || !state.visible || !automatic()) {
      pauseClip(video, state);
    } else if (!state.userPaused && video.paused) {
      video.play().catch(() => { /* Native controls remain available when autoplay is blocked. */ });
    }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = clips.get(entry.target);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
      updateClip(entry.target, state);
    });
  }, { threshold: [0, 0.15] }) : null;
  function initialize(root = document) {
    root.querySelectorAll('.t225-component-video video, .t225-product-details video').forEach(video => {
      if (clips.has(video)) return;
      // Keep the poster and no-preload markup; fetch media only once it is visible.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.controls = true;
      const state = { visible: false, userPaused: false, internalPause: false };
      clips.set(video, state);
      video.dataset.tbwClipPlayback = observer && automatic() ? 'viewport' : 'manual';
      video.addEventListener('pause', () => {
        if (state.internalPause) state.internalPause = false;
        else if (state.visible && !document.hidden) state.userPaused = true;
      });
      video.addEventListener('play', () => { state.userPaused = false; });
      observer?.observe(video);
    });
  }
  function refresh() { clips.forEach((state, video) => updateClip(video, state)); }
  document.addEventListener('visibilitychange', refresh);
  motion.addEventListener('change', refresh);
  connection?.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
